import React, { Component } from "react";
import { get as _get, isEqual as _isEqual, isEmpty as _isEmpty } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Helmet from "react-helmet";

import { showAlertMessage, EmptyLabel } from "../../resusableComponents/common/formElements";
import { hasAccess } from "../../resusableComponents/hoc/AccessManagement";
import { fetchLogo } from "../../helpers/utils";
import { withRouter } from "../../resusableComponents/hoc/withRouter";
import PowerBIDashboard from "../../resusableComponents/common/PowerBIDashboard";
import MarkAsButton from "../../resusableComponents/common/MarkAsButton";
import DeepResearchReportButton from "../../resusableComponents/common/DeepResearchReportButton";

import { fetchCampaignDashboardData, clearCampaignDashboardError } from "../../redux/actions/campaign";
import { fetchCampaignPowerBIToken } from "../../redux/services/campaign";
import { updateLoadingState } from "../../redux/actions/application";

class PBICampaignDashboard extends Component {

  constructor(props) {
    super(props);


    this.state = {
      campaignDetails: {},
      tilesData: {},
      campaignId: _get(this.props, "params.id", 0),
      powerBI: {},
      reloadCampaignDashboard: false
    }
  }

  componentDidMount() {
    const { fetchCampaignDashboardData } = this.props;
    const { campaignId } = this.state;

    if (typeof fetchCampaignDashboardData === "function") {
      fetchCampaignDashboardData(campaignId || 0);
    }
    this._fetchPowerBIConfiguration();
    this._setDashboardData();
  }

  componentDidUpdate(prevProps, prevState) {

    if (!_isEqual(prevProps.dashboardData, this.props.dashboardData) && !_isEmpty(this.props.dashboardData)) {
      const { dashboardData, clearCampaignDashboardError } = this.props;
      const responseFlag = _get(dashboardData, "flag", null);

      if (responseFlag === null) { return false; }

      if (responseFlag === true) {
        showAlertMessage(_get(dashboardData, "message", "Campaign dashboard data fetched successfully."), "success");

        this._setDashboardData();
      } else if (responseFlag === false) {
        showAlertMessage(_get(dashboardData, "message", "Something went wrong while fetching campaign dashboard data."));

        if (typeof clearCampaignDashboardError === "function") { clearCampaignDashboardError(); }
      }
    }

    if (!_isEqual(prevState.reloadCampaignDashboard, this.state.reloadCampaignDashboard) && (_get(this.state, "reloadCampaignDashboard", false) === true)) {
      const { fetchCampaignDashboardData } = this.props;
      const { campaignId } = this.state;

      if (typeof fetchCampaignDashboardData === "function") {
        fetchCampaignDashboardData(campaignId || 0);
      }
      this.setState({ reloadCampaignDashboard: false });
    }
  }

  _fetchPowerBIConfiguration = async () => {
    const { updateLoadingState, intl } = this.props;
    const { campaignId } = this.state;

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await fetchCampaignPowerBIToken("campaign_dashboard", { campaign_id: (campaignId || 0) });

      if ((response.flag || false) === true) {
        this.setState({ powerBI: _get(response, "data", {}) });
      } else {
        showAlertMessage((response.message || intl.formatMessage({ id: "campaign_dashboard.error_while_fetching_report_details", defaultMessage: "Something went wrong while fetching report details." })));
      }
    } catch (error) {
      showAlertMessage((error.message || intl.formatMessage({ id: "campaign_dashboard.error_while_fetching_report_details", defaultMessage: "Something went wrong while fetching report details." })));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  };

  _setDashboardData = () => {
    const { dashboardData } = this.props;

    this.setState({
      campaignDetails: _get(dashboardData, "data.campaign_details[0]", {}),
      tilesData: _get(dashboardData, "data.campaign_numbers[0]", {})
    });
  };

  _renderTiles = () => {
    const { tilesData, campaignId } = this.state;

    const hasApproveLeadLinkPermission = hasAccess("campaigns", "dashboard", ["approved-leads-link"]);
    const hasRejectedLeadLinkPermission = hasAccess("campaigns", "dashboard", ["rejected-leads-link"]);
    const hasPendingLeadLinkPermission = hasAccess("campaigns", "dashboard", ["pending-leads-link"]);

    return (
      <div className="row gy-4 mt-2">
        <div className="col-lg-3">
          <div className="card-static border-blue-55">
            <h6 className="text-blue-55">{_get(tilesData, "complete_percent", 0)}</h6>
            <p className="text-capitalize"><FormattedMessage id="campaign_dashboard.tiles.completed" defaultMessage="completed" /></p>
          </div>
        </div>
        <div className="col-lg-3">
          <Link to={(hasApproveLeadLinkPermission) ? `/campaigns/approved-leads/${(campaignId || null)}` : "#"}>
            <div className="card-static border-success">
              <h6 className="text-success">{_get(tilesData, "approved_leads", 0)}</h6>
              <p className="text-capitalize"><FormattedMessage id="campaign_dashboard.tiles.approved_leads" defaultMessage="approved leads" /></p>
            </div>
          </Link>
        </div>
        <div className="col-lg-3">
          <Link to={(hasRejectedLeadLinkPermission) ? `/campaigns/rejected-leads/${(campaignId || null)}` : "#"}>
            <div className="card-static border-danger">
              <h6 className="text-danger">{_get(tilesData, "rejected_leads", 0)}</h6>
              <p className="text-capitalize"><FormattedMessage id="campaign_dashboard.tiles.rejected_leads" defaultMessage="rejected leads" /></p>
            </div>
          </Link>
        </div>
        <div className="col-lg-3">
          <Link to={(hasPendingLeadLinkPermission) ? `/campaigns/pending-leads/${(campaignId || null)}` : "#"}>
            <div className="card-static border-warning">
              <h6 className="text-warning">{_get(tilesData, "pending_leads", 0)}</h6>
              <p className="text-capitalize"><FormattedMessage id="campaign_dashboard.tiles.pending_leads" defaultMessage="pending leads" /></p>
            </div>
          </Link>
        </div>
      </div>
    );
  }

  _renderCampaignButtons = () => {
    const { campaignId, campaignDetails } = this.state;

    return (
      <div className="row">
        <div className="col-lg-12">
          <div className="d-flex flex-wrap gap-3 align-items-center">
            {(hasAccess("campaigns", "dashboard", ["edit-campaign"])) && (
              <Link to={`/campaigns/edit/${campaignId}`} className="btn btn-outline-primary text-capitalize waves-effect">
                <FormattedMessage id="campaign_dashboard.btn.edit_campaign" defaultMessage="edit campaign" />
              </Link>
            )}

            {(hasAccess("campaigns", "dashboard", ["campaign-content"])) && (
              <Link to={`/campaigns/content/${campaignId}`} className="btn btn-outline-primary text-capitalize waves-effect">
                <FormattedMessage id="campaign_dashboard.btn.campaign_content" defaultMessage="campaign content" />
              </Link>
            )}

            {(hasAccess("campaigns", "dashboard", ["upload-leads"])) && (
              <Link to={`/campaigns/upload-lead/${campaignId}`} className="btn btn-outline-primary text-capitalize waves-effect">
                <FormattedMessage id="campaign_dashboard.btn.upload_leads" defaultMessage="upload leads" />
              </Link>
            )}

            {(hasAccess("campaigns", "dashboard", ["data-history"])) && (
              <Link to={`/campaigns/data-history/${campaignId}`} className="btn btn-outline-primary waves-effect">
                <FormattedMessage id="campaign_dashboard.btn.data_history" defaultMessage="data history" />
              </Link>
            )}

            {(hasAccess("campaigns", "dashboard", ["view-leads"])) && (
              <Link to={`/campaigns/view-leads/${campaignId}`} className="btn btn-outline-primary text-capitalize waves-effect">
                <FormattedMessage id="campaign_dashboard.btn.view_leads" defaultMessage="view leads" />
              </Link>
            )}

            {(hasAccess("campaigns", "dashboard", ["mark-as-complete"]) && !_get(campaignDetails, "is_completed", false)) && (
              <MarkAsButton
                className="btn btn-outline-primary waves-effect"
                buttonId="campaign_list.button.mark_as_complete"
                buttonDefultMessage="mark as complete"
                operationStatus="complete"
                selectedCampaignIds={[campaignId]}
                source="campaign_dashboard"
                setState={(args) => this.setState(args)}
              />
            )}

            {(hasAccess("campaigns", "dashboard", ["mark-as-live"]) && (_get(campaignDetails, "is_completed", false) === true)) && (
              <MarkAsButton
                className="btn btn-outline-primary waves-effect"
                buttonId="campaign_list.button.mark_as_live"
                buttonDefultMessage="mark as live"
                operationStatus="live"
                selectedCampaignIds={[campaignId]}
                source="campaign_dashboard"
                setState={(args) => this.setState(args)}
              />
            )}

            {(hasAccess("campaigns", "dashboard", ["deep-research-report"]) && (_get(campaignDetails, "is_completed", false) === true)) && (
              <DeepResearchReportButton
                campaignId={campaignId}
                reportStatus={_get(campaignDetails, "report_status", null)}
                deepResearchClassName="btn btn-outline-primary waves-effect"
                viewReportClassName="btn btn-outline-primary waves-effect"
              />
            )}

          </div>
        </div>
      </div>
    );
  }

  render() {
    const { intl } = this.props;
    const { campaignDetails, powerBI } = this.state;

    const logoURL = (fetchLogo(_get(campaignDetails, "client_website", "")) || require("../../assets/images/no-img-icon.png").default);

    return (
      <>
        <Helmet>
          <title> {intl.formatMessage({ id: "hermes.campaign_dashboard", defaultMessage: "Campaign Dashboard: Hermes" })} </title>
        </Helmet>

        <div className="container-fluid flex-grow-1 px-6 py-6">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center gap-5 py-3 px-4">
                    <img className="img-fluid me-5" width="30" src={(logoURL || "")} alt="" />
                    <p className="heading-04 text-uppercase">
                      {_get(campaignDetails, "campaign_name", <EmptyLabel />)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {this._renderTiles()}

          <div className="row mt-5">
            <div className="col-lg-12">
              <h1 className="heading-04 fw-semibold text-dark-35 text-uppercase mb-5">
                <FormattedMessage id="campaign_dashboard.title" defaultMessage="dashboard" />
              </h1>
            </div>
          </div>

          {this._renderCampaignButtons()}

          {(hasAccess("campaigns", "pbi-dashboard", ["page-view"])) && (
            <>
              <div className="row mt-6">
                <div className="col-lg-12">
                  <div className="powerbi-section">
                    <PowerBIDashboard
                      reportId={_get(powerBI, "report_id", "")}
                      groupId={_get(powerBI, "workspace_id", "")}
                      embedUrl={_get(powerBI, "app_url", "")}
                      filter={_get(powerBI, "filter", "")}
                      accessToken={_get(powerBI, "access_token", "")}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, props) => ({
  dashboardData: _get(state, "campaign.dashboard", {}),
});

const mapDispatchToProps = (dispatch) => ({
  clearCampaignDashboardError: () => dispatch(clearCampaignDashboardError()),
  fetchCampaignDashboardData: (data) => dispatch(fetchCampaignDashboardData(data)),
  updateLoadingState: (payload) => dispatch(updateLoadingState(payload)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(PBICampaignDashboard)));
